import { compose } from 'recompose';

import { map } from 'helpers/safeRamda';
import { theme } from 'config';
import { sortMonthTransformer, Scale } from 'scenes/Report/Report.helper';

type BarValues = {
  transactionDate: string;
  cashbackAmount: number;
};

type LineValues = {
  transactionDate: string;
  totalTransactionAmount: number;
};

const legendItems = [
  {
    title: 'Total Transaction Amount',
    color: theme.seafoamGreen,
  },
  {
    title: 'Cashback Amount',
    color: theme.violet,
  },
];

const lineChartTransformer = map(
  (LineValue: LineValues): Scale => ({
    x: LineValue.transactionDate,
    y: LineValue.totalTransactionAmount,
  }),
) as Function;

const barChartTransformer = map(
  (BarValue: BarValues): Scale => ({
    x: BarValue.transactionDate,
    y: BarValue.cashbackAmount,
  }),
) as Function;

const barTransformers = compose(
  barChartTransformer,
  sortMonthTransformer('transactionDate'),
) as any;

const lineTransformers = compose(
  lineChartTransformer,
  sortMonthTransformer('transactionDate'),
) as any;

export {
  barTransformers,
  lineTransformers,
  BarValues,
  LineValues,
  legendItems,
};
